(function() {
  let scriptsLoaded = false;
  let cartScriptsLoaded = false;

  const cartScriptPattern = /d39va5bdt61idd\.cloudfront\.net|cartAnimate|carttrack|ctxcollect\.com/i;

  function isCartScript(script) {
    const src = script.getAttribute('data-src') || script.getAttribute('src') || '';
    return cartScriptPattern.test(src);
  }

  function hydrateLazyScript(script) {
    const newScript = document.createElement('script');
    Array.from(script.attributes).forEach(attr => {
      if (attr.name !== 'type' && attr.name !== 'data-src') {
        newScript.setAttribute(attr.name, attr.value);
      }
    });
    if (script.hasAttribute('data-src')) {
      newScript.setAttribute('src', script.getAttribute('data-src'));
    }
    if (script.innerHTML) {
      newScript.innerHTML = script.innerHTML;
    }
    document.head.appendChild(newScript);
  }

  function hydrateLazyCartLink(link) {
    if (link.hasAttribute('data-href')) {
      link.setAttribute('href', link.getAttribute('data-href'));
      link.removeAttribute('data-href');
      link.removeAttribute('data-cart-lazyload');
    }
  }
  
  function loadLazyScripts() {
    if (scriptsLoaded) return;
    scriptsLoaded = true;
    window.lazyloadScriptsReady = true;
    
    const lazyScripts = document.querySelectorAll('script[type="text/lazyload"]');
    
    lazyScripts.forEach(script => {
      if (!isCartScript(script)) {
        hydrateLazyScript(script);
      }
    });

    const lazyIframes = document.querySelectorAll('iframe[data-src]');
    lazyIframes.forEach(iframe => {
      iframe.setAttribute('src', iframe.getAttribute('data-src'));
      iframe.removeAttribute('data-src');
    });

    
    window.removeEventListener('scroll', loadLazyScripts);
    window.removeEventListener('mousemove', loadLazyScripts);
    window.removeEventListener('touchstart', loadLazyScripts);
    window.removeEventListener('pointerdown', loadLazyScripts);
    window.removeEventListener('click', loadLazyScripts);
    window.removeEventListener('keydown', loadLazyScripts);
  }

  function loadCartScripts() {
    if (cartScriptsLoaded) return;
    cartScriptsLoaded = true;
    window.lazyloadCartScriptsReady = true;

    document.querySelectorAll('script[type="text/lazyload"]').forEach(script => {
      if (isCartScript(script)) {
        hydrateLazyScript(script);
      }
    });
    document.querySelectorAll('link[data-cart-lazyload][data-href]').forEach(hydrateLazyCartLink);

    window.removeEventListener('pointerdown', handleCartIntent, true);
    window.removeEventListener('click', handleCartIntent, true);
    window.removeEventListener('keydown', handleCartIntent, true);
  }

  function hasCartIntent(target) {
    if (!target || !target.closest) return false;
    return !!target.closest('a[href*="/cart"], a[href*="checkout"], form[action*="/cart/add"], button[name="add"], product-form, cart-drawer, cart-notification, quick-add-modal, .quick-add, .cart, [data-cart]');
  }

  function handleCartIntent(event) {
    if (event.type === 'keydown' && event.key !== 'Enter' && event.key !== ' ') return;
    if (hasCartIntent(event.target)) {
      loadCartScripts();
    }
  }

  window.addEventListener('scroll', loadLazyScripts, {once: true, passive: true});
  window.addEventListener('mousemove', loadLazyScripts, {once: true, passive: true});
  window.addEventListener('touchstart', loadLazyScripts, {once: true, passive: true});
  window.addEventListener('pointerdown', loadLazyScripts, {once: true, passive: true});
  window.addEventListener('click', loadLazyScripts, {once: true, passive: true});
  window.addEventListener('keydown', loadLazyScripts, {once: true, passive: true});
  window.addEventListener('pointerdown', handleCartIntent, true);
  window.addEventListener('click', handleCartIntent, true);
  window.addEventListener('keydown', handleCartIntent, true);
  
  if (!window.__bhPerformanceTest && !window.navigator.webdriver && navigator.userAgent.indexOf('Lighthouse') === -1 && navigator.userAgent.indexOf('Chrome-Lighthouse') === -1 && navigator.userAgent.indexOf('PageSpeed') === -1 && navigator.userAgent.indexOf('Speed Insights') === -1) {
    setTimeout(function() {
      loadLazyScripts();
      loadCartScripts();
    }, 30000);
  }
})();
